module.exports = __webpack_public_path__ + "static/media/Royal_Fishing.5d5963d8.png";